var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppConfig from '../../config/config';
import { mapAndEnrichProducts, mapFilters, mapMeta, mapSorts } from './mapper';
import { fetchAlgolia } from './api';
export class AlgoliaSearchProvider {
    constructor() {
        this.products = [];
        this.filters = [];
        this.meta = null;
        this.sortOptions = [];
        this.currentFilters = {};
    }
    search(query_1) {
        return __awaiter(this, arguments, void 0, function* (query, options = {}) {
            const { page = 1, pageSize = AppConfig.page.defaultSize, sort = 'relevance', filters, merchandising } = options;
            if (filters) {
                this.updateFilters(filters);
            }
            try {
                // Convert MerchandisingConfig to Algolia's expected format
                const algoliaMerchandising = merchandising ? {
                    ruleContexts: merchandising.ruleContexts,
                    abTest: merchandising.abTest && merchandising.abTest.testId ? {
                        testId: merchandising.abTest.testId,
                        variantId: merchandising.abTest.variant || (merchandising.abTest.variantId ? parseInt(merchandising.abTest.variantId) : undefined)
                    } : undefined,
                    userProfile: merchandising.userProfile,
                    enableRules: merchandising.enableRules,
                    enablePersonalization: merchandising.enablePersonalization,
                    merchandisingFilters: merchandising.merchandisingFilters
                } : undefined;
                const data = yield fetchAlgolia({
                    q: query,
                    page,
                    pageSize,
                    sort,
                    filters: this.currentFilters,
                    merchandising: algoliaMerchandising,
                });
                // Map products and enrich with variant data in a single optimized call
                this.products = yield mapAndEnrichProducts(data.hits);
                this.filters = mapFilters(data.facets || {}, data.facets_stats, this.currentFilters, data.facetConfig);
                this.meta = mapMeta(data);
                this.sortOptions = mapSorts();
            }
            catch (error) {
                console.error('Error fetching from Algolia:', error);
                throw error;
            }
        });
    }
    updateFilters(newFilters) {
        // Replace the current filters with the new filters (no toggle behavior)
        // This ensures UI state and URL params stay in sync
        this.currentFilters = {};
        Object.entries(newFilters).forEach(([filterId, values]) => {
            if (values.length > 0) {
                this.currentFilters[filterId] = [...values]; // Copy the array
            }
            // If values is empty, we don't add it to currentFilters (effectively removing it)
        });
    }
    getProducts() {
        return this.products;
    }
    getFilters() {
        return this.filters;
    }
    getMeta() {
        if (!this.meta) {
            throw new Error('No search has been performed yet');
        }
        return this.meta;
    }
    getSortOptions() {
        return this.sortOptions;
    }
    getCurrentFilters() {
        return this.currentFilters;
    }
}
